import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocAlertIssueSyncingDetailRoute: InvariantJiraRoute = {
	name: 'eoc-alert-issue-syncing-detail',
	path: '/jira/settings/products/ops/syncs/:syncId',
	exact: true,
};
